// Build-time feature flags.
//
// Flags are driven by REACT_APP_* environment variables defined per-environment
// in .env-cmdrc (dev / staging / prod) and inlined by Create React App at build
// time. Because env values are always strings, compare against 'true' to derive
// a real boolean.
//
// Use these flags to enable not-yet-prod-ready features in dev/staging while
// keeping them hidden in production, instead of branch-divergent commenting.
//
// Convention: for a feature "X", add REACT_APP_FEATURE_X to all three .env-cmdrc
// sections (true for dev/staging, false for prod) and export an X_ENABLED flag
// here. Gate nav items via `enabled: X_ENABLED` (ListNavigationTab / HeaderSideBar
// only render items with enabled === true) and gate routes via conditional spread
// so the route object is omitted entirely when the flag is off.

export const FLEET_AI_ENABLED = process.env.REACT_APP_FEATURE_FLEET_AI === 'true';

export const REPORTS_ENABLED = process.env.REACT_APP_FEATURE_REPORTS === 'true';

// O/D Analytics Safety / Idle tabs, and the Route Map's safety + idle overlays and deck
// panels. All of it reads per-packet telemetry (greenDriving, overspeeding, ignition,
// ambient temp) that GET /v3/trip does not return, and all of it is served today by
// GET /v3/trip/analytics. This flag also gates the analytics fetch itself.
export const OD_TELEMETRY_ENGINES_ENABLED = process.env.REACT_APP_FEATURE_OD_TELEMETRY_ENGINES === 'true';

// The Route Map trip tape only. Split out of OD_TELEMETRY_ENGINES because the tape is the
// one piece that needs a *per-trip trail* endpoint — timestamped positions — while everything
// above ships on data the analytics endpoint already returns. One flag for both would keep the
// finished work dark until the trail lands, which is what it did until this split.
export const OD_TRIP_TAPE_ENABLED = process.env.REACT_APP_FEATURE_OD_TRIP_TAPE === 'true';
